import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import buildAffiliateLink from 'lib/buildAffiliateLink';
import { isTelemundoVertical } from 'lib/vertical';

import { isLengthGreaterThan8 } from 'lib/fontBasedOnTextLength';
import { getDateTime } from 'lib/DateTime';
import ShopButton from './ShopButton';

const ENCODER_STOP_DATE = 'Wed Apr 15 2020 00:00:00';

const ShopButtonInfo = (
  {
    name,
    listPrice,
    salePrice,
    productUrl,
    seller,
    additionalStyles,
    block,
    isLink,
    articlePublishDate,
    vertical,
  }, { canonicalUrl },
) => {
  /**
    If an articlePublishDate is provided we need to determine if the articlePublishDate
    is after the ENCODER_STOP_DATE (isCurrentArticlePublishedAfterEncoderStopDate)
    because then we wouldn't need to build the affiliate link in Ramen
  */
  let isCurrentArticlePublishedAfterEncoderStopDate;
  if (articlePublishDate) {
    const fetchedEncoderStopDate = getDateTime(ENCODER_STOP_DATE);
    const fetchedCurrentArticlePublishDate = getDateTime(articlePublishDate);
    // eslint-disable-next-line max-len
    isCurrentArticlePublishedAfterEncoderStopDate = fetchedCurrentArticlePublishDate > fetchedEncoderStopDate;
  }
  const isWaffle = block === 'WaffleProduct';
  const affiliateUrl = isCurrentArticlePublishedAfterEncoderStopDate
    ? productUrl
    : buildAffiliateLink(productUrl, canonicalUrl);

  const isLongerThan8Chars = isLengthGreaterThan8(seller);
  const bemElemPriceBtn = `${block}__priceBtn`;
  const costStyles = [bemElemPriceBtn, additionalStyles.cost,
    { 'shop-button-info__cost-fit-text': isLongerThan8Chars }];
  const body = (
    <>
      <span className={classNames(costStyles, 'shop-button-info__cost')}>
        {salePrice && (
          <div className="red b">
            $
            {salePrice}
          </div>
        )}
        <div className={classNames('gray-60 b', { 'strike fw5': salePrice })}>
          $
          {listPrice}
        </div>
      </span>
      <ShopButton
        additionalStyles={additionalStyles}
        block={block}
        isWaffle={isWaffle}
        listPrice={listPrice}
        name={name}
        seller={seller}
      />
    </>
  );
  if (isLink) {
    return (
      <a
        className={classNames(
          `${block}__shopButtons`,
          'shop-button-info__shop',
          { 'shop-button-info__shop-fit-text': isLongerThan8Chars },
          additionalStyles.shop,
        )}
        href={isTelemundoVertical(vertical) ? productUrl : affiliateUrl}
        rel="noopener"
        target="_blank" // eslint-disable-line react/jsx-no-target-blank
        key={affiliateUrl}
      >
        {body}
      </a>
    );
  }
  return (
    <div
      className={classNames(
        `${block}__shopButtons`,
        'shop-button-info__shop',
        { 'shop-button-info__shop-fit-text': isLongerThan8Chars },
        additionalStyles.shop,
      )}
      key={affiliateUrl}
    >
      {body}
    </div>
  );
};

ShopButtonInfo.propTypes = {
  name: PropTypes.string.isRequired,
  listPrice: PropTypes.string.isRequired,
  salePrice: PropTypes.string,
  articlePublishDate: PropTypes.string,
  productUrl: PropTypes.string.isRequired,
  seller: PropTypes.string,
  additionalStyles: PropTypes.shape({
    shop: PropTypes.string,
    cost: PropTypes.string,
    vendor: PropTypes.string,
    icon: PropTypes.string,
    vendorName: PropTypes.string,
  }),
  block: PropTypes.string,
  isLink: PropTypes.bool,
  vertical: PropTypes.string,
};

ShopButtonInfo.defaultProps = {
  seller: null,
  isLink: true,
  salePrice: '',
  articlePublishDate: '',
  additionalStyles: PropTypes.shape({
    shop: '',
    cost: '',
    vendor: '',
    icon: '',
    vendorName: '',
  }),
  block: 'ListicleProduct',
  vertical: null,
};

ShopButtonInfo.contextTypes = {
  canonicalUrl: PropTypes.string,
};

export default ShopButtonInfo;
